import { Component, EventEmitter, Input, Output } from '@angular/core';
import OptionGroup from '../../../smoothr-web-app-core/models/OptionGroup';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import Article from '../../../smoothr-web-app-core/models/Article';
import { getPrice, numberD, numberToCurrency } from '../../../smoothr-web-app-core/utils/utils';
import { DisplayIdentifier } from '../../../smoothr-web-app-core/enums/DisplayIdentifier';
import { OrderType } from '../../../smoothr-web-app-core/enums/OrderType';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { getAvailability } from '../../../smoothr-web-app-core/utils/utils';
import { AllergensInfoModalComponent } from '../allergens-info-modal/allergens-info-modal.component';
import { ModalController } from '@ionic/angular';

@Component({
	selector: 'app-article-option-group-checkbox',
	templateUrl: './article-option-group-checkbox.component.html',
	styleUrls: ['article-option-group-checkbox.component.scss'],
})
export class ArticleOptionGroupCheckboxComponent {
	optionGroup: OptionGroup = null;
	@Input() set optionGroupValue(value: OptionGroup) {
		console.log('INPUT', value);
		if (value) {
			if (value.articles.length > 0) {
				value.articles = value.articles.filter(it => !this.isHidden(it) && !it.hidden);
				console.log('value for option group', value);
				this.optionGroup = value;
			}
		}
	}
	@Input() selected: ArticleOption[];
	@Input() article: Article;
	@Input() currency: string;
	@Input() preorderType: PreorderType;
	@Input() hasMultiple: boolean;
	@Output() selection = new EventEmitter<ArticleOption>();
	@Output() openInfo = new EventEmitter<Article>();
	@Input() filtersValues: string[] = [];

	showFirstArticles = true;

	ot = OrderType;
	di = DisplayIdentifier;
	numberToCurrency = numberToCurrency;
	getPrice = getPrice;
	numberD = numberD;

	constructor(private modalCtrl: ModalController) {}

	isHidden(article: Article): boolean {
		return this.preorderType && !getAvailability(article, OrderType.PREORDER, this.preorderType);
	}

	onSelectionChange(article: Article, quantity: number) {
		if (this.isDisabled(article)) {
			return;
		}
		const articleOption = new ArticleOption();
		articleOption.article = article;
		articleOption.group = this.optionGroup._id;
		articleOption.quantity = quantity;
		this.selection.emit(articleOption);
	}

	toggle(option: Article) {
		if (this.hasMultiple) {
			return;
		}
		this.onSelectionChange(option, this.selected.map(ao => ao.article?._id).indexOf(option?._id) < 0 ? 1 : -1);
	}

	isDisabled(option: Article): boolean {
		return option.requirements && option.requirements.min > 0 && this.isOptionSelected(option);
	}

	isOptionSelected(option: Article): boolean {
		return this.selected.find(sel => sel.article._id === option._id && sel.group === this.optionGroup._id) !== undefined;
	}

	async openInfoClick(option: Article) {
		await AllergensInfoModalComponent.show(this.modalCtrl, option);
	}
	isAllergens(article: Article) {
		if (article?.compound?.allergens) return Object.values(article?.compound?.allergens)?.find(it => it === true);
		else return null;
	}

	isAddit(article: Article) {
		if (article?.compound?.additives) return Object.values(article?.compound?.additives)?.find(it => it === true);
		else return null;
	}
	isHaveAnyValueMoreZero(article: any) {
		if (!article?.nutritions) {
			return null;
		}
		return Object.values(article?.nutritions)
			.map(it => (numberD(it) ? numberD(it) : 0))
			.find(it => it > 0);
	}

	increaseOption(article: Article) {
		const option = new ArticleOption();
		option.article = article;
		option.quantity = 1;
		option.group = this.optionGroup._id;

		this.selection.emit(option);
	}

	decreaseOption(article: Article) {
		const option = new ArticleOption();
		option.article = article;
		option.quantity = -1;
		option.group = this.optionGroup._id;

		this.selection.emit(option);
	}

	totalCount(): number {
		return this.selected.reduce((prev, curr) => prev + curr.quantity, 0);
	}

	count(article: Article): number {
		return this.selected
			.filter(articleOption => articleOption.article._id === article._id)
			.reduce((prev, curr) => prev + curr.quantity, 0);
	}
	ifFilterVisible(article: Article) {
		if (this.filtersValues.length === 0) {
			return false;
		}
		let articleFilter = false;
		this.filtersValues.forEach(it => {
			if (it == 'meat') {
				if (
					article?.compound?.features &&
					(article.compound.features['beef'] === true ||
						article.compound.features['chicken'] === true ||
						article.compound.features['pork'] === true)
				) {
					articleFilter = true;
				}
			}
			if (article.compound.features?.[it] && !!article.compound.features[it]) {
				articleFilter = true;
			}
			if (article?.compound?.allergens && it === 'gluten' && article.compound.allergens['cerealsContainingGluten'] == true) {
				articleFilter = true;
			}
			if (article?.compound?.allergens && it === 'peanut' && article.compound.allergens['peanutsAndProductsThereof'] == true) {
				articleFilter = true;
			}
			if (article?.compound?.allergens && it === 'lactose' && article.compound.allergens['milkAndProductsThereof'] == true) {
				articleFilter = true;
			}
		});
		return articleFilter;
	}
}
